function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcNoDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264.697,
    height: 196.138,
    viewBox: "0 0 264.697 196.138",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2850",
    transform: "translate(-1310.5 -1888.738)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2946",
    d: "M244.226 717.325H50.527a22.286 22.286 0 0 1 0-44.573h193.7a22.286 22.286 0 0 1 0 44.573",
    transform: "translate(1287.633 1344.016)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2945",
    d: "M431.878 216.588H298.087a29.246 29.246 0 0 1 0-58.492h133.79a29.246 29.246 0 1 1 0 58.492",
    transform: "translate(1092.822 1760.729)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5782",
    width: 160,
    height: 174,
    rx: 10,
    transform: "translate(1310.5 1903.785)",
    style: {
      fill: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2947",
    d: "M496.371 504.843q-.7.053-1.412.052h-127.7a19.722 19.722 0 0 1 0-39.444h127.7q.714 0 1.412.051a19.721 19.721 0 0 0 0 39.341",
    transform: "translate(1029.107 1511.865)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2949",
    d: "M159.587 251.4v154.705a9.709 9.709 0 0 1-15.454 7.828L0 284.138V251.4a9.71 9.71 0 0 1 9.709-9.709h140.168a9.71 9.71 0 0 1 9.709 9.709",
    transform: "translate(1310.5 1662.043)",
    style: {
      fill: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "M440.979 251.4v36.64a80.884 80.884 0 0 1-93.448-46.349h83.739a9.71 9.71 0 0 1 9.709 9.709",
    transform: "translate(1029.107 1661.043)",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 539",
    transform: "translate(1310.5 1888.738)",
    style: {
      fill: "none"
    },
    d: "M0 0h264.697v196.138H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2849",
    transform: "translate(722.5 1480.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5783",
    width: 116,
    height: 12,
    rx: 6,
    transform: "translate(612 462)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5789",
    width: 116,
    height: 12,
    rx: 6,
    transform: "translate(612 486)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5790",
    width: 116,
    height: 12,
    rx: 6,
    transform: "translate(612 509)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5791",
    width: 116,
    height: 12,
    rx: 6,
    transform: "translate(612 532)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5792",
    width: 116,
    height: 12,
    rx: 6,
    transform: "translate(612 554)",
    style: {
      fill: "#d8d8d8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2951",
    d: "M639.769 429.786v61.133a33.354 33.354 0 1 1 0-61.133",
    transform: "translate(830.316 1543)",
    style: {
      fill: "#5d5d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2952",
    d: "M593.046 427.169a33.355 33.355 0 1 0 33.354-33.355 33.355 33.355 0 0 0-33.355 33.355",
    transform: "translate(830.316 1569.869)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2953",
    d: "M742.5 484.7v16.64c0 5.254-1.579 9.673-8.335 9.673-6.248 0-7.946-4.359-7.946-9.613v-16.315c0-6.016 2.588-9.6 8.248-9.6 5.552 0 8.034 3.495 8.034 9.222m-10.872-.275v17.608c0 2.59.777 3.994 2.738 3.994s2.678-1.455 2.678-4.148v-17.593c0-2.4-.753-3.832-2.684-3.832-1.844 0-2.731 1.268-2.731 3.967",
    transform: "translate(722.488 1503.746)",
    style: {
      fill: "#333"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcNoDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-noDocument.b3da8f75d4006e658a4f8df1fc7aef72.svg";